export default __webpack_public_path__ + "static/media/mathMore3.ae770f5a.png";